module.exports = __webpack_public_path__ + "static/attractions-3.4d5e39a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/attractions-3.jpg
// module id = 485
// module chunks = 249749550194671